import {PartnerExpertWritePayload} from '../../services/partnerExpertService'

// Pure form <-> payload helpers for the partner-expert registration (WP-X8). Unit-testable.

export interface PartnerExpertForm {
  headline: string
  bio: string
  listedRate: string // kept as an input string; mapped to number|null on submit
  currency: string
  rateType: string
  availabilityNote: string
  expertiseAreas: number[]
  isListed: boolean
  active: boolean
}

export const EMPTY_FORM: PartnerExpertForm = {
  headline: '',
  bio: '',
  listedRate: '',
  currency: 'usd',
  rateType: '',
  availabilityNote: '',
  expertiseAreas: [],
  isListed: true,
  active: true,
}

// Toggle a catalog id in the selected expertise-areas list.
export const toggleArea = (ids: number[], id: number): number[] =>
  ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]

// Prefill the form from an existing ExpertProfile (read shape).
export const formFromProfile = (p: any): PartnerExpertForm => ({
  headline: p?.headline ?? '',
  bio: p?.bio ?? '',
  listedRate: p?.listedRate != null ? String(p.listedRate) : '',
  currency: p?.currency ?? 'usd',
  rateType: p?.rateType ?? '',
  availabilityNote: p?.availabilityNote ?? '',
  expertiseAreas: (p?.expertiseAreas ?? []).map((a: any) => a.id),
  isListed: p?.isListed ?? true,
  active: p?.active ?? true,
})

// Map the form to the write payload (listedRate '' → null; camelCase keys the parser converts).
export const buildPayload = (f: PartnerExpertForm): PartnerExpertWritePayload => ({
  headline: f.headline,
  bio: f.bio,
  listedRate: f.listedRate === '' ? null : Number(f.listedRate),
  currency: f.currency,
  rateType: f.rateType,
  availabilityNote: f.availabilityNote,
  expertiseAreas: f.expertiseAreas,
  isListed: f.isListed,
  active: f.active,
})
